import { Gear } from "@phosphor-icons/react";
import { Container, ConfigAction, Box } from "./styles";

import { Popover } from "../Popover";
import { ConfigContent } from "./ConfigContent";
import _ from "lodash";

export function Config({ children, name, empty, inverse, twoColunms, option }) {
  const popoverToogle = Popover.store((st) => st.actions.toogle);
  const zIndex = _.isBoolean(option) ? 2 : _.toInteger(option);

  if (empty) return <Container />;
  const gridColumn = twoColunms ? 'span 2 / span 2' : 'span 1 / span 1';

  return (
    <Container style={{ gridColumn }}>
      <Box>
        <ConfigAction
          inverse={inverse}
          onClick={() => popoverToogle(name)}
        >
          <Gear weight="fill" size={20} />
        </ConfigAction>
        <ConfigContent name={name} zIndex={zIndex}>{children}</ConfigContent>
      </Box>
    </Container>
  );
}
